import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

export interface CodeGemRequest {
  prompt: string;
  level: string;
  passionLevel: number;
  patternId: string;
  userAttempt: string;
}

interface CodeGemResponse {
  message?: string;
  reply?: string;
  output?: string;
}

@Injectable({
  providedIn: 'root'
})
export class CodeGemService {
  private readonly endpoint = 'https://gujna7kcv42rvjazqtezesmt2a0ifpcv.lambda-url.us-east-1.on.aws/';

  constructor(private http: HttpClient) {}

  codeGem(request: CodeGemRequest): Observable<string> {
    return this.http.post<CodeGemResponse>(this.endpoint, request).pipe(
      map((response) => response?.message || response?.reply || response?.output || 'Gemini did not return a message yet.')
    );
  }
}
